import React from "react";
import { generatePath, Outlet, useParams } from "react-router-dom";
import { useCrumb } from "@poseidon/ui/app/crumbs/CrumbContext";
import {
  SailorProvider,
  useSailorContext,
  useSailorRiskProfileContext,
} from "./SailorContext";
import { RouterTabs } from "@poseidon/ui/components/RouterTabs";
import { BaseRoutePathProvider } from "@poseidon/utils/base-route-path";
import { AgreementSailorProvider } from "./AgreementSailorContext";
import { VulnerableSailorAlert } from "./components/SailorVulnerabilityFlags";

const tabs = [
  {
    to: "",
    label: "Edit Sailor",
  },
  {
    to: `/identityChecks`,
    label: "Identity Checks",
  },
  {
    to: `/creditUnderwriting`,
    label: "Credit Underwriting",
  },
  {
    to: `/applications`,
    label: "Applications",
  },
  {
    to: `/agreements`,
    label: "Agreements",
  },
];

function SailorsFlags() {
  const sailor = useSailorContext();
  const riskProfile = useSailorRiskProfileContext();
  return <VulnerableSailorAlert sailor={sailor} riskProfile={riskProfile} />;
}

const SailorsOutlet = ({ baseRoutePath, listDisabled }) => {
  useCrumb(`${baseRoutePath ?? ""}/sailors/`, {
    to: listDisabled ? null : `${baseRoutePath ?? ""}/sailors`,
    text: "Sailors",
  });
  const params = useParams();
  const { sailorId } = params;
  if (params["*"].includes("agreement-sailors")) {
    const baseHref = generatePath(
      `${baseRoutePath ?? ""}/agreement-sailors/:sailorId`,
      params
    );
    const { applicationId } = params;
    return (
      <BaseRoutePathProvider route={baseRoutePath ?? ""}>
        <AgreementSailorProvider
          applicationId={applicationId}
          sailorId={sailorId}
        >
          <RouterTabs
            tabs={[
              {
                to: "",
                label: "Agreement Sailor Record",
              },
            ]}
            baseHref={baseHref}
          />
        </AgreementSailorProvider>
      </BaseRoutePathProvider>
    );
  }
  if (sailorId) {
    const baseHref = generatePath(
      `${baseRoutePath ?? ""}/sailors/:sailorId`,
      params
    );
    return (
      <BaseRoutePathProvider route={baseRoutePath ?? ""}>
        <SailorProvider sailorId={sailorId}>
          {/* Nested routes (e.g. under an application) already show the
              application-level vulnerability flags */}
          {!baseRoutePath && <SailorsFlags />}
          <RouterTabs tabs={tabs} baseHref={baseHref} />
        </SailorProvider>
      </BaseRoutePathProvider>
    );
  } else {
    return (
      <BaseRoutePathProvider route={baseRoutePath ?? ""}>
        <Outlet />;
      </BaseRoutePathProvider>
    );
  }
};

export default SailorsOutlet;
